module.exports = __webpack_public_path__ + "static/img/002.b89e9c5c.png";